(function () {
  var COMPANY_ID = 'HyDiUd';
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID;

  function init(root) {
    if (root.dataset.swReady) return;
    root.dataset.swReady = '1';
    var openBtn = root.querySelector('[data-sw-open]');
    var form = root.querySelector('[data-sw-form]');
    var email = root.querySelector('[data-sw-email]');
    var submit = root.querySelector('[data-sw-submit]');
    var msg = root.querySelector('[data-sw-msg]');

    openBtn.addEventListener('click', function () {
      form.hidden = false;
      openBtn.hidden = true;
      email.focus();
    });

    submit.addEventListener('click', function () {
      var value = (email.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)) {
        msg.textContent = 'Please enter a valid email address.';
        return;
      }
      submit.disabled = true;
      msg.textContent = 'One moment…';

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Seasonal waitlist — ' + root.dataset.product,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: value,
                    properties: { 'Waitlist Product': root.dataset.product }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: root.dataset.list } } }
          }
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('subscribe failed: ' + res.status);
          form.querySelector('[data-sw-email]').hidden = true;
          submit.hidden = true;
          msg.textContent = "You're on the list — we'll email you first.";
        })
        .catch(function () {
          submit.disabled = false;
          msg.textContent = 'Something went wrong. Please try again.';
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-seasonal-waitlist]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();
